import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'admin-sidebar-collapsed'

class SidebarCollapseController extends Controller {
  connect () {
    this.apply(localStorage.getItem(STORAGE_KEY) === 'true')
  }

  toggle () {
    const collapsed = this.element.dataset.collapsed !== 'true'
    localStorage.setItem(STORAGE_KEY, collapsed)
    this.apply(collapsed)
  }

  apply (collapsed) {
    this.element.dataset.collapsed = collapsed
    this.element.querySelectorAll('.admin-nav-item').forEach(item => {
      if (collapsed) {
        item.title = item.dataset.tooltip || ''
      } else {
        item.removeAttribute('title')
      }
    })
  }
}

export default SidebarCollapseController
